import React, { useEffect, useState } from 'react';
import api, { fmtDate } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { ChangePasswordCard } from '@/components/ChangePassword';
import { Loading } from '@/components/Shared';
import { Truck, FileCheck, AlertTriangle } from 'lucide-react';

export default function DriverProfile() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => { api.get('/driver/me').then((r) => setD(r.data)); }, []);
  if (!d) return <Loading />;
  return (
    <div className="space-y-4">
      <div className="rounded-xl border border-border bg-card p-4 flex items-center gap-3">
        <img src={d.photo} alt="me" className="h-14 w-14 rounded-full object-cover bg-muted" />
        <div><h2 className="font-display text-lg font-semibold">{d.name}</h2><p className="text-sm text-muted-foreground">{d.phone} · Rating {d.rating}★</p></div>
      </div>
      {d.vehicle && (
        <div className="rounded-xl border border-border bg-card p-4"><div className="flex items-center gap-2"><Truck className="h-5 w-5 text-primary" /><div><p className="font-medium">{d.vehicle.vehicle_number}</p><p className="text-xs text-muted-foreground">{d.vehicle.vehicle_type} · {d.vehicle.tank_capacity}L capacity</p></div></div></div>
      )}
      <div>
        <p className="font-semibold mb-2">Documents</p>
        <div className="space-y-2">
          {(d.documents || []).map((doc) => (
            <div key={doc.id} className="rounded-xl border border-border bg-card p-3 flex items-center justify-between">
              <div className="flex items-center gap-2"><FileCheck className="h-4 w-4 text-primary" /><div><p className="text-sm font-medium">{doc.doc_type}</p><p className="text-xs text-muted-foreground">{doc.number} · Expires {fmtDate(doc.expiry_date)}</p></div></div>
            </div>
          ))}
          {(!d.documents || d.documents.length === 0) && <p className="text-sm text-muted-foreground">No documents on file.</p>}
        </div>
      </div>
      <ChangePasswordCard />
    </div>
  );
}
